import { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { HeroSection } from '../components/house/HeroSection';
import { KeyFacts } from '../components/house/KeyFacts';
import { ProgressSection } from '../components/house/ProgressSection';
import { LocationSection } from '../components/house/LocationSection';
import { LifestyleReel } from '../components/house/LifestyleReel';
import { OwnershipOptions } from '../components/house/OwnershipOptions';
import { FloorPlans } from '../components/house/FloorPlans';
import { ArchitectureSection } from '../components/house/ArchitectureSection';
import { BuilderSection } from '../components/house/BuilderSection';
import { OverseasBuyers } from '../components/house/OverseasBuyers';
import { EnquireSection } from '../components/house/EnquireSection';
import { BookingModal } from '../components/house/BookingModal';

export default function The126House() {
  const [bookingVariant, setBookingVariant] = useState(null);

  useEffect(() => {
    const open = (e) => setBookingVariant(e.detail || 'viewing');
    window.addEventListener('open-viewing', open);
    const id = window.location.hash.slice(1);
    const t = id && setTimeout(() => document.getElementById(id)?.scrollIntoView(), 400);
    return () => { window.removeEventListener('open-viewing', open); clearTimeout(t); };
  }, []);

  return (
    <div className="min-h-screen bg-[#1a1e1a]">
      <Header />
      <HeroSection />
      <KeyFacts />
      <ProgressSection />
      <LocationSection />
      <LifestyleReel />
      <OwnershipOptions onSelect={setBookingVariant} />
      <FloorPlans />
      <ArchitectureSection />
      <BuilderSection />
      <OverseasBuyers />
      <EnquireSection />
      <Footer />
      <BookingModal variant={bookingVariant} onClose={() => setBookingVariant(null)} />
    </div>
  );
}
